"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPostTabsContext = exports.ACTION_TYPES = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var lodash_1 = __importDefault(require("lodash"));
var schemaSlice_1 = require("../../features/post/schemaSlice");
var PostTabsContext_1 = require("../../contexts/PostTabsContext");
var deviceHelper_1 = require("../../helpers/deviceHelper");
var postSlice_1 = require("../../features/post/postSlice");
exports.ACTION_TYPES = {
    CLICK: 'click',
    STOP: 'stop',
    SCROLL: 'scroll',
};
var NewPostTabsContext = function (_a) {
    var children = _a.children;
    var steps = react_redux_1.useSelector(schemaSlice_1.selectPostSections);
    var post = react_redux_1.useSelector(postSlice_1.selectCurrentPost);
    var _b = react_1.useState(0), scrollPosition = _b[0], setScrollPosition = _b[1];
    var _c = react_1.useState({
        deal: '',
        propertyType: '',
    }), changedPostSchemaItems = _c[0], setChangedSchemaItems = _c[1];
    var _d = react_1.useState(false), isFormErrors = _d[0], setIsFormErrors = _d[1];
    var reducer = function (state, action) {
        var _a, _b;
        if (action.type === 'initialState') {
            return __assign(__assign({}, state), { goal: null, activeTab: action.payload.postTabs.activeTab, tabs: __spreadArray([], action.payload.postTabs.tabs.map(function (step, index) {
                    return __assign(__assign({}, step), { itemPosition: null, tabTopPosition: null, tabBottomPosition: null, viewed: index === 0, active: false });
                })) });
        }
        if (action.type === 'itemPositionChange') {
            return __assign(__assign({}, state), { tabs: state.tabs.map(function (tab) {
                    if (tab.name === action.payload.name) {
                        return __assign(__assign({}, tab), { itemPosition: action.payload.itemPosition });
                    }
                    return tab;
                }) });
        }
        if (action.type === 'tabPositionChange') {
            return __assign(__assign({}, state), { tabs: (_a = state.tabs) === null || _a === void 0 ? void 0 : _a.map(function (tab) {
                    if (tab.name === action.payload.name) {
                        return __assign(__assign({}, tab), { tabTopPosition: action.payload.tabTopPosition, tabBottomPosition: action.payload.tabBottomPosition });
                    }
                    return tab;
                }) });
        }
        if (action.type === 'viewed') {
            return __assign(__assign({}, state), { tabs: (_b = state.tabs) === null || _b === void 0 ? void 0 : _b.map(function (tab) {
                    if (tab.name === action.payload.name) {
                        return __assign(__assign({}, tab), { viewed: true });
                    }
                    return tab;
                }) });
        }
        if (action.type === 'active') {
            return __assign(__assign({}, state), { activeTab: action.payload.name });
        }
        if (action.type === 'goal') {
            return __assign(__assign({}, state), { goal: action.payload.goal });
        }
    };
    var _e = react_1.useReducer(reducer, []), tabsStatus = _e[0], tabDispatch = _e[1];
    react_1.useEffect(function () {
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    react_1.useEffect(function () {
        if (tabsStatus.activeTab && tabsStatus.tabs && tabsStatus) {
            handleTabChange('scroll');
        }
    }, [scrollPosition]);
    react_1.useEffect(function () {
        if (!lodash_1.default.size(tabsStatus.tabs) && post && steps.length) {
            if (post.isDeveloper && steps.length === 6) {
                initializeTabs();
            }
            else if (!post.isDeveloper && steps.length) {
                initializeTabs();
            }
        }
    }, [steps, post]);
    react_1.useEffect(function () {
        if (tabsStatus.goal) {
            var tab = getTab(tabsStatus.goal, tabsStatus.tabs);
            if (tab) {
                var tubSize = (deviceHelper_1.isMobile() ? 2 : 1) * tab.itemPosition;
                window.scroll(0, tab.tabTopPosition - tubSize);
            }
        }
    }, [tabsStatus.goal]);
    var initializeTabs = function () {
        tabDispatch({
            type: 'initialState',
            payload: {
                postTabs: {
                    activeTab: steps[0].name,
                    tabs: steps,
                },
            },
        });
    };
    var getTab = function (tabName, tabs) {
        return tabs.find(function (element) { return element.name == tabName; });
    };
    var handleScroll = function () {
        setScrollPosition(window.pageYOffset);
    };
    var handleActiveChange = function (tabName) {
        tabDispatch({
            type: 'active',
            payload: {
                name: tabName,
            },
        });
        handleViewedChange(tabName);
    };
    var handleGoalChange = function (tabName) {
        if (tabName === void 0) { tabName = null; }
        tabDispatch({
            type: 'goal',
            payload: {
                goal: tabName,
            },
        });
    };
    var handleViewedChange = function (tabName) {
        tabDispatch({
            type: 'viewed',
            payload: {
                name: tabName,
            },
        });
    };
    var handleItemPositionChange = function (tabName, itemPosition) {
        tabDispatch({
            type: 'itemPositionChange',
            payload: {
                name: tabName,
                itemPosition: itemPosition,
            },
        });
    };
    var handleTabPositionChange = function (tabName, tabTopPosition, tabBottomPosition) {
        if (tabName === steps[0].name) {
            tabDispatch({
                type: 'tabPositionChange',
                payload: {
                    name: tabName,
                    tabTopPosition: document.body.scrollTop,
                    tabBottomPosition: tabBottomPosition,
                },
            });
        }
        else if (tabName === steps[steps.length - 1].name) {
            tabDispatch({
                type: 'tabPositionChange',
                payload: {
                    name: tabName,
                    tabTopPosition: tabTopPosition,
                    tabBottomPosition: document.body.scrollHeight,
                },
            });
        }
        else {
            tabDispatch({
                type: 'tabPositionChange',
                payload: {
                    name: tabName,
                    tabTopPosition: tabTopPosition,
                    tabBottomPosition: tabBottomPosition,
                },
            });
        }
    };
    var handleTabChange = function (type, tabName) {
        if (tabName === void 0) { tabName = ''; }
        if (type == exports.ACTION_TYPES.CLICK) {
            var tab = getTab(tabName, tabsStatus.tabs);
            if (tab) {
                window.scroll(0, tab.tabTopPosition - tab.itemPosition);
            }
        }
        if (type == exports.ACTION_TYPES.SCROLL) {
            var newTab = tabsStatus.tabs.find(function (tab) {
                return (tab.tabTopPosition - tab.itemPosition <=
                    scrollPosition + tabsStatus.tabs[0].itemPosition * 2 &&
                    scrollPosition + tabsStatus.tabs[0].itemPosition * 2 <=
                        tab.tabBottomPosition - tab.itemPosition);
            });
            if (newTab && newTab.name != tabsStatus.activeTab) {
                handleActiveChange(newTab.name);
                handleGoalChange(null);
            }
        }
    };
    var handleChangeSchema = function (value) {
        setChangedSchemaItems(value);
    };
    var defaultValue = {
        handleActiveChange: handleActiveChange,
        handleViewedChange: handleViewedChange,
        handleItemPositionChange: handleItemPositionChange,
        handleTabPositionChange: handleTabPositionChange,
        handleTabChange: handleTabChange,
        handleGoalChange: handleGoalChange,
        postTabs: tabsStatus,
        handleChangeSchema: handleChangeSchema,
        changedPostSchemaItems: changedPostSchemaItems,
        isFormErrors: isFormErrors,
        setIsFormErrors: setIsFormErrors,
    };
    return (react_1.default.createElement(PostTabsContext_1.PostTabsContext.Provider, { value: defaultValue }, children));
};
exports.NewPostTabsContext = NewPostTabsContext;
